<template>
  <div>
    <div style="background: #fff">
      <div class="width-max top-menu">
        <img :src="require('@/assets/logoH1.png')" class="menu-logo" />
        <!-- <img :src="info.logUrl" :title="info.name" class="menu-logo" /> -->
        <el-menu mode="horizontal" text-color="#16181A" active-text-color="#366AFF" :default-active="key" router>
          <el-menu-item index="home">首页</el-menu-item>
          <el-menu-item index="cintroduction">大赛介绍</el-menu-item>
          <el-menu-item index="news">新闻公告</el-menu-item>
          <!-- <el-menu-item @click="login">团队报名</el-menu-item> -->
          <el-menu-item index="menu" v-if="isLogin">我的团队</el-menu-item>
          <el-menu-item index="platform">竞赛平台</el-menu-item>
          <el-menu-item index="fileDownload">资料下载</el-menu-item>
          <el-menu-item index="download">证书下载</el-menu-item>
          <el-menu-item @click="gocompany">思睿启明</el-menu-item>
          <el-submenu v-if="isLogin" index="">
            <template slot="title"><span
                style="display: inline-block;max-width:120px;text-overflow: ellipsis;overflow: hidden;">{{ userinfo.username || '个人中心' }}</span></template>
            <el-menu-item index="userinfo">个人设置</el-menu-item>
            <el-menu-item @click.native="loginout">退出登录</el-menu-item>
          </el-submenu>
          <el-menu-item index="login" v-else>团队登录</el-menu-item>
        </el-menu>
      </div>
    </div>
    <router-view :key="key" />
    <div class="footer">
      <div class="width-max">
        <div class="jszc-top">
          <div class="jszc-title">联系我们</div>
          <div>如果您有问题可以通过以下方式联系我们</div>
          <div class="jszc">
            <div><i class="el-icon-user-solid"></i>竞赛联系人：任凭</div>
            <div><i class="el-icon-phone"></i>联系电话：18957959585</div>
            <div>
              <i class="el-icon-location"></i>联系地址:浙江金华婺城区北二环西路3439号浙师大网络经济创业园3号楼211
            </div>
          </div>
          <div class="beian">
            <p>Copyright©2018-至今 - 思睿智训 - E-Mail：service@srzx.com</p>
          </div>
        </div>
        <el-divider direction="vertical"></el-divider>
        <div class="jszc-top">
          <div class="jszc-title">技术支持单位</div>
          <!-- <div>鸣谢以下单位给与技术支持</div> -->
          <div class="jszc">
            <div v-for="item in info.tsus" :key="item">{{ item }}</div>
          </div>
          <div class="beian">
            <p>浙ICP备18007420号-2 浙公网安备 33070202100263号</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: "home",
    };
  },
  computed: {
    isLogin() {
      return this.$store.getters.token ? true : false;
    },
    userinfo() {
      return this.$store.getters.userinfo;
    },
    info() {
      let info = this.$store.getters.info;
      info.tsus = info.tsu.split(",");
      return info;
    },
    key() {
      let key = this.$route.path.split("/").pop();
      if (["upload", "apply", "userinfo", "score", 'menu'].includes(key)) {
        key = "menuMod";
      }
      if (["cert", "certdownload"].includes(key)) {
        key = "download";
      }
      return key;
    },
  },
  mounted() {
    document.title = this.info.name;
  },
  methods: {
    gocompany() {
      window.open(" http://www.srqm.net/");
    },
    login() {
      // window.open("https://www.bricsacademy.org.cn/signup/index");
    },
    loginout() {
      this.$store.commit("SETTOKEN", null);
      if (this.$router.currentRoute.path !== '/pc/home') {
        this.$router.replace({ name: "Home" });
      }
      
    },
  },
};
</script>

<style lang="scss" scoped>
.top-menu {
  background-color: #fff;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;

  .el-menu {
    display: inline-block;

    .el-menu-item {
      font-size: 16px;
    }

    ::v-deep .el-submenu__title {
      font-size: 16px;
    }
  }
}

.menu-logo {
  font-size: 16px;
  font-family: YouSheBiaoTiHei;
  height: 50px;
  line-height: 50px;
  margin-left: 0;
  margin-right: auto;
}

.el-menu--horizontal {
  border-bottom: 0;

  .el-menu-item {
    font-size: 17px;
    border-bottom: 0;
    padding: 0 16px;
  }
}

.footer {
  background: #fff;
  box-shadow: 0px 2px 39px 0px rgba(163, 166, 199, 0.48);
  font-size: 16px;

  .width-max {
    display: flex;
    position: relative;
  }

  .el-divider {
    background-color: #d3d6da;
    margin: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scaleX(50%);
    height: 133px;
  }

  .jszc-top {
    flex: 50%;

    &:last-child {
      margin-left: 147px;
    }

    .jszc-title {
      padding-top: 46px;
      font-size: 24px;
      font-family: YouSheBiaoTiHei;
      color: #366aff;
      margin-bottom: 30px;
    }

    .jszc {
      margin-top: 38px;
      height: 89px;
      display: flex;
      flex-direction: column;

      >div {
        flex: 1;
      }

      i {
        color: #366aff;
        font-size: 17px;
        margin-right: 4px;
      }
    }

    .beian {
      padding: 39px 0 34px;
      display: flex;
      justify-content: space-between;

      >p {
        flex: 1;
      }
    }
  }
}
</style>
